import styled from 'styled-components';

export const UploadImage = styled.div`
  & .dropzone-style {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 1.25rem;
            border-radius: .75rem;
            border: 1px dashed #BDBDBD;
            background: #FFFFFF;
            color: #475467;
            font-weight: 400;
            font-size: 14px;
            line-height: 1.25rem;
            outline: none;
            transition: border .24s ease-in-out;
            margin-top: .5rem;
            min-height: 13.5rem;

            & .body{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                cursor: pointer;

                & div{
                    font-weight: 600;
                    font-size:  1rem;
                    line-height: 1.125rem;
                    display: inline-block;
                }

                & svg{
                    font-weight: 600;
                    font-size:  1.5rem;
                    line-height: 1.125rem;
                    color: #000;
                    margin: .5rem 0;
                }
            }
        }
`

export const StyledSearchInput = styled.div`  
    width: 100%;
    /* padding: 12px 0; */
    position: relative;
    display: flex;
    flex-wrap: wrap;

  & svg{
    position: absolute;
    top: 4px;
    left: 5px;
  }

  & input,input:focus{
    font-weight: 500;
    width: 100%;
    height: 32px;
    padding: 7px 7px 7px 30px;
    border-radius: 15px;
    font-size: 14px;
    background: rgb(251, 251, 255);
    -webkit-text-fill-color: rgb(127, 130, 161);
    color: rgb(127, 130, 161);
    border: 1px solid ${props => (props?.fromImageUrl && !props?.isImageValid) ? 'red' :'rgb(200, 209, 230)' };

  }
`

export const CoverImageWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 1rem 0;
  /* max-height: 40rem;
  overflow-y: auto; */



  @media (max-height: 54rem) {
   height: 28rem;
  }

  & img{
    width: 10.1rem;
    height: 10.1rem;
    margin: 0 1rem 1rem .2rem;
    cursor: pointer;
    
    &:active{
      border: 1px solid #0D55FF;
    }
  }
`

export const ImagePreview = styled.div`
  display: flex;
  width: 100%;
  height: 22rem;
  margin-top: 1rem;
  background: #FBFBFF;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  color: #7F82A1;

  & img{
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
`

export const ImageLinkFooter = styled.div`
  display: flex;
  height: 4.57rem;
  width: 100%;
  background: #F4F4FF;
  align-items: center;
  gap: .6rem;
  padding-left: 4rem;
  position: absolute;
  bottom: 0;
  left: 0;

  & button{
    display: flex;
    width: 11.07rem;
    height: 2.28rem;
    border: 1px solid #C8D1E5;
    border-radius: 7rem;
    align-items: center;
    justify-content: center;
    color: #181818;
    background-color: #FBFBFF;

    &.insert{
      background: #181818;
      box-shadow: 0px 4px 8px 0px #18181833;
      font-weight: 700;
      color: white;
      cursor: pointer;
    }
  }
`